import { useEffect, useRef } from 'react'

import { useCartStore } from '@/stores/cart-store/cartStore'
import { useStepStore } from '@/stores/step-store/stepStore'

export const useLocationDependency = () => {
	const location = useCartStore.use.location()
	const removeAllRooms = useCartStore.use.removeAllRooms()
	const resetTravelPeriod = useCartStore.use.resetTravelPeriod()
	const resetSteps = useStepStore.use.resetSteps()

	const hotelCode = location?.hotelCode
	const hotelCodeRef = useRef<string | undefined>(hotelCode)

	useEffect(() => {
		const reset = () => {
			removeAllRooms()
			resetTravelPeriod()
			resetSteps(['ROOM_SELECTION', 'TRAVEL_PERIOD'])
		}

		if (!hotelCodeRef.current && hotelCode) {
			hotelCodeRef.current = hotelCode
			return
		}

		if (hotelCodeRef.current && !hotelCode) {
			reset()
			return
		}

		if (hotelCodeRef.current && hotelCode && hotelCodeRef.current !== hotelCode) {
			reset()
			return
		}
	}, [hotelCode, removeAllRooms, resetSteps, resetTravelPeriod])
}
